const KEY = "xprotect_projects_v1";

export function loadProjects() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    if (!Array.isArray(arr)) return [];
    return arr;
  } catch {
    return [];
  }
}

export function saveProject(project) {
  const projects = loadProjects();
  const existingIdx = projects.findIndex((p) => p.id === project.id);
  const now = new Date().toISOString();
  const payload = { ...project, updatedAt: now, createdAt: project.createdAt || now };
  if (existingIdx >= 0) projects[existingIdx] = payload;
  else projects.unshift(payload);
  localStorage.setItem(KEY, JSON.stringify(projects));
  return payload;
}

export function deleteProject(id) {
  const projects = loadProjects().filter((p) => p.id !== id);
  localStorage.setItem(KEY, JSON.stringify(projects));
  return projects;
}

export function newProjectId() {
  return `proj_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}
